module.exports = __webpack_public_path__ + "static/media/mental-health.c2d6a35a.jpg";